"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _DashboardSimpleFilter = _interopRequireDefault(require("./DashboardSimpleFilter"));

var _DashboardCategoryFilter = _interopRequireDefault(require("./DashboardCategoryFilter"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _service = require("@insided/deprecated-control/analytics/service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AiModerationDashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AiModerationDashboard, _Component);

  var _super = _createSuper(AiModerationDashboard);

  function AiModerationDashboard() {
    var _this;

    (0, _classCallCheck2.default)(this, AiModerationDashboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", function () {
      var _getStartAndEndDate = (0, _utils.getStartAndEndDate)(),
          initialStartDate = _getStartAndEndDate.initialStartDate,
          initialEndDate = _getStartAndEndDate.initialEndDate,
          initalDateRangeId = _getStartAndEndDate.initalDateRangeId;

      var selectedDate = (0, _utils.getDefaultSelectedDate)();
      var queryParams = new _QueryParameters.default();
      return {
        approvedContent: (0, _utils.createDefaultMetricItem)(),
        trashedContent: (0, _utils.createDefaultMetricItem)(),
        spamContent: (0, _utils.createDefaultMetricItem)(),
        userRoles: [],
        selectedRoles: queryParams.has('roles') ? queryParams.get('roles').split(',') : [],
        mainRoles: [],
        customRoles: [],
        isUserRoleDropdownOpen: false,
        contentTypes: [],
        selectedContentTypes: queryParams.has('content_types') ? queryParams.get('content_types').split(',') : [],
        isContentTypeDropdownOpen: false,
        selectedPresetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
        startDate: queryParams.has('date_from') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_from')) : initialStartDate,
        endDate: queryParams.has('date_till') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_till')) : initialEndDate,
        selectedDate: selectedDate,
        presetDateRangeList: [],
        isDateRangeOpen: false,
        isLoading: false,
        storedState: {
          presetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
          selectedDateRange: selectedDate
        },
        isApprovedContentLoading: false,
        isTrashedContentLoading: false,
        isSpamContentLoading: false,
        selectedCategories: queryParams.has('categories') ? queryParams.get('categories').split(',') : [],
        isCategoryDropdownOpen: false
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, presetDateRanges, _userRoles, contentTypes, defaultDateRange, _dateRangeForDisplay, _dateFrom, _dateTill, selectedDateRange, selectedPresetId, updatedState;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _utils.trackDashboardUsage)('ai-moderation-dashboard');

              _this.setState({
                isApprovedContentLoading: true,
                isTrashedContentLoading: true,
                isSpamContentLoading: true,
                isLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return Promise.all([(0, _service.fetchDateRangeFilter)(), (0, _service.fetchUserRoles)().then(function (roleList) {
                return (0, _utils.normalizeRoles)(roleList);
              }), (0, _utils.fetchContentTypes)()]);

            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 3);
              presetDateRanges = _yield$Promise$all2[0];
              _userRoles = _yield$Promise$all2[1];
              contentTypes = _yield$Promise$all2[2];
              defaultDateRange = (0, _utils.getDefaultDateRange)(presetDateRanges, _this.state.selectedPresetDateRangeId);
              _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(_this.state.storedState, defaultDateRange, _this.state.selectedPresetDateRangeId), _dateFrom = _dateRangeForDisplay.dateFrom, _dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState;

              _this.setState({
                contentTypes: contentTypes,
                selectedPresetDateRangeId: selectedPresetId,
                selectedDate: selectedDateRange,
                storedState: updatedState,
                isLoading: false
              });

              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](2);

              _this.setState({
                isLoading: false
              });

            case 18:
              _this.fetchApprovedContentData();

              _this.fetchTrashedContentData();

              _this.fetchSpamContentData();

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 15]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var _this$state = _this.state,
          isDateRangeOpen = _this$state.isDateRangeOpen,
          isUserRoleDropdownOpen = _this$state.isUserRoleDropdownOpen,
          isContentTypeDropdownOpen = _this$state.isContentTypeDropdownOpen,
          isCategoryDropdownOpen = _this$state.isCategoryDropdownOpen;

      if (isDateRangeOpen || isUserRoleDropdownOpen || isContentTypeDropdownOpen || isCategoryDropdownOpen) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.setState({
          isDateRangeOpen: false,
          isUserRoleDropdownOpen: false,
          isContentTypeDropdownOpen: false,
          isCategoryDropdownOpen: false
        });

        _this.removeHandler();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refetchData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.fetchApprovedContentData();

              _this.fetchTrashedContentData();

              _this.fetchSpamContentData();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchApprovedContentData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var res, _res$data, count, previousCount, percentageDifference;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                isApprovedContentLoading: true
              });

              _context3.prev = 1;
              _context3.next = 4;
              return _this.fetchData('/analyticsV2/approvedContentKeyInsights');

            case 4:
              res = _context3.sent;
              _res$data = res.data, count = _res$data.count, previousCount = _res$data.previousCount;
              percentageDifference = (0, _utils.previousPeriodDifference)(count, previousCount);

              _this.setState({
                approvedContent: {
                  count: count,
                  previousCount: previousCount,
                  percentageDifference: percentageDifference
                },
                isApprovedContentLoading: false
              });

              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);

              _this.setState({
                isApprovedContentLoading: false
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchTrashedContentData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var res, _res$data2, count, previousCount, percentageDifference;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                isTrashedContentLoading: true
              });

              _context4.prev = 1;
              _context4.next = 4;
              return _this.fetchData('/analyticsV2/trashedContentKeyInsights');

            case 4:
              res = _context4.sent;
              _res$data2 = res.data, count = _res$data2.count, previousCount = _res$data2.previousCount;
              percentageDifference = (0, _utils.previousPeriodDifference)(count, previousCount);

              _this.setState({
                trashedContent: {
                  count: count,
                  previousCount: previousCount,
                  percentageDifference: percentageDifference
                },
                isTrashedContentLoading: false
              });

              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);

              _this.setState({
                isTrashedContentLoading: false
              });

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchSpamContentData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var res, _res$data3, count, previousCount, percentageDifference;

      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.setState({
                isSpamContentLoading: true
              });

              _context5.prev = 1;
              _context5.next = 4;
              return _this.fetchData('/analyticsV2/spamContentKeyInsights');

            case 4:
              res = _context5.sent;
              _res$data3 = res.data, count = _res$data3.count, previousCount = _res$data3.previousCount;
              percentageDifference = (0, _utils.previousPeriodDifference)(count, previousCount);

              _this.setState({
                spamContent: {
                  count: count,
                  previousCount: previousCount,
                  percentageDifference: percentageDifference
                },
                isSpamContentLoading: false
              });

              _context5.next = 13;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](1);

              _this.setState({
                isSpamContentLoading: false
              });

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(url) {
        var additionalFilterOptions,
            _this$state2,
            selectedContentTypes,
            selectedCategories,
            filterOptions,
            _args6 = arguments;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                additionalFilterOptions = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                _this$state2 = _this.state, selectedContentTypes = _this$state2.selectedContentTypes, selectedCategories = _this$state2.selectedCategories; // Only send filters that Unified API supports

                filterOptions = {
                  contentTypes: selectedContentTypes,
                  categories: selectedCategories
                };
                _context6.next = 5;
                return _axios.default.post(url, {
                  filters: Object.assign(filterOptions, additionalFilterOptions)
                });

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUserRoleDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isUserRoleDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserRolesChanged", function (data) {
      _this.setState({
        isUserRoleDropdownOpen: false
      });

      window.history.pushState(null, 'roles changed', new _QueryParameters.default().set('roles', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetUserRoles", function () {
      _this.setState({
        isUserRoleDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearUserRoles", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        isUserRoleDropdownOpen: false
      });

      window.history.pushState(null, 'roles cleared', new _QueryParameters.default().unset('roles').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleContentTypeDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isContentTypeDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContentTypesChanged", function (data) {
      _this.setState({
        isContentTypeDropdownOpen: false,
        selectedContentTypes: data
      });

      window.history.pushState(null, 'content types changed', new _QueryParameters.default().set('content_types', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetContentTypes", function () {
      _this.setState({
        isContentTypeDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearContentTypes", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedContentTypes: [],
        isContentTypeDropdownOpen: false
      });

      window.history.pushState(null, 'content_types cleared', new _QueryParameters.default().unset('content_types').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDateRange", function (value) {
      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isDateRangeOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPresetDateRangeChanged", function (selectedDate) {
      _this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomDateRangeChanged", function (dates) {
      var _dates = (0, _slicedToArray2.default)(dates, 2),
          startDate = _dates[0],
          endDate = _dates[1];

      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: startDate,
        endDate: endDate
      };

      _this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateRangeChanged", function () {
      var _this$state3 = _this.state,
          selectedDate = _this$state3.selectedDate,
          selectedPresetDateRangeId = _this$state3.selectedPresetDateRangeId;

      _this.setState(function (prevState) {
        return {
          isDateRangeOpen: false,
          storedState: _objectSpread(_objectSpread({}, prevState.storedState), {}, {
            presetDateRangeId: selectedPresetDateRangeId,
            selectedDateRange: selectedDate
          })
        };
      });

      var queryString = new _QueryParameters.default();
      queryString.set('date_range', selectedPresetDateRangeId);

      if (selectedPresetDateRangeId !== 'custom_range') {
        queryString.unset('date_from').unset('date_till');
      } else {
        queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
      }

      window.history.pushState(null, 'date range changed', queryString.getQueryString());
      (0, _utils.updateDateRangeInSessionStorage)(selectedDate);

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetDateRange", function () {
      var _this$state$storedSta = _this.state.storedState,
          presetDateRangeId = _this$state$storedSta.presetDateRangeId,
          selectedDateRange = _this$state$storedSta.selectedDateRange;

      _this.setState({
        isDateRangeOpen: false,
        selectedPresetDateRangeId: presetDateRangeId,
        selectedDate: selectedDateRange
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategoryDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      _this.setState({
        isCategoryDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategoriesChanged", function (data) {
      _this.setState({
        selectedCategories: data,
        isCategoryDropdownOpen: false
      });

      window.history.pushState(null, 'categories changed', new _QueryParameters.default().set('categories', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetCategories", function () {
      _this.setState({
        isCategoryDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearCategories", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedCategories: [],
        isCategoryDropdownOpen: false
      });

      window.history.pushState(null, 'categories cleared', new _QueryParameters.default().unset('categories').getQueryString());

      _this.refetchData();
    });
    return _this;
  }

  (0, _createClass2.default)(AiModerationDashboard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var categoriesV2 = this.props.categoriesV2;
      var _this$state4 = this.state,
          isApprovedContentLoading = _this$state4.isApprovedContentLoading,
          isTrashedContentLoading = _this$state4.isTrashedContentLoading,
          isSpamContentLoading = _this$state4.isSpamContentLoading,
          approvedContent = _this$state4.approvedContent,
          trashedContent = _this$state4.trashedContent,
          spamContent = _this$state4.spamContent,
          contentTypes = _this$state4.contentTypes,
          selectedContentTypes = _this$state4.selectedContentTypes,
          isContentTypeDropdownOpen = _this$state4.isContentTypeDropdownOpen,
          isLoading = _this$state4.isLoading,
          selectedCategories = _this$state4.selectedCategories,
          isCategoryDropdownOpen = _this$state4.isCategoryDropdownOpen;
      return (0, _preact.h)("div", {
        className: "ai-moderation-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "ai-moderation-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "AI Moderation Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, (0, _preact.h)(_DashboardCategoryFilter.default, {
        isLoading: isLoading,
        id: "categories",
        name: "(parent) category or group",
        customClassName: "categories",
        title: "Published in",
        isDropdownOpen: isCategoryDropdownOpen,
        toggleDropdown: this.toggleCategoryDropdown,
        resetDropdown: this.onResetCategories,
        onClear: this.onClearCategories,
        onChange: this.onCategoriesChanged,
        categoriesV2: categoriesV2,
        selectedItems: selectedCategories
      }), (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "contentType",
        name: "content type",
        customClassName: "content-type",
        title: "Content type",
        isDropdownOpen: isContentTypeDropdownOpen,
        toggleDropdown: this.toggleContentTypeDropdown,
        resetDropdown: this.onResetContentTypes,
        onClear: this.onClearContentTypes,
        onChange: this.onContentTypesChanged,
        items: contentTypes,
        selectedItems: selectedContentTypes,
        "data-element-name": "Content type filter",
        "data-track-type": "click"
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Approved content",
        total: approvedContent.count,
        titleTooltip: "The number of topics and replies that have been approved by moderation in the selected time period.",
        isLoading: isApprovedContentLoading,
        percent: approvedContent.percentageDifference,
        comparisionTooltip: "The percentage difference between approved content in the current/previous time period.",
        showComparisionUnavailable: approvedContent.previousCount === 0
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Trashed content",
        total: trashedContent.count,
        titleTooltip: "The number of topics and replies that have been moved to trash by moderation in the selected time period.",
        isLoading: isTrashedContentLoading,
        percent: trashedContent.percentageDifference,
        comparisionTooltip: "The percentage difference between trashed content in the current/previous time period.",
        showComparisionUnavailable: trashedContent.previousCount === 0
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Spam content",
        total: spamContent.count,
        titleTooltip: "The number of topics and replies that have been marked as spam by moderation in the selected time period.",
        isLoading: isSpamContentLoading,
        percent: spamContent.percentageDifference,
        comparisionTooltip: "The percentage difference between spam content in the current/previous time period.",
        showComparisionUnavailable: spamContent.previousCount === 0
      })), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return AiModerationDashboard;
}(_preact.Component);

var _default = AiModerationDashboard;
exports.default = _default;